import { render, staticRenderFns } from "./PackageColumnChart.vue?vue&type=template&id=621475e4&scoped=true"
import script from "./PackageColumnChart.vue?vue&type=script&lang=js"
export * from "./PackageColumnChart.vue?vue&type=script&lang=js"
import style0 from "./PackageColumnChart.vue?vue&type=style&index=0&id=621475e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621475e4",
  null
  
)

export default component.exports